export default {"src":"/_next/static/media/Car.6e31577c.svg","height":24,"width":24};